var _path, _path2;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgCoupon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.74855 16.2859L16.32 7.71442M0.857117 18.8573C0.857116 19.3113 1.03726 19.7469 1.35801 20.0683C1.67876 20.3896 2.11391 20.5707 2.56797 20.5716H21.432C21.886 20.5707 22.3212 20.3896 22.6419 20.0683C22.9627 19.7469 23.1428 19.3113 23.1428 18.8573V15.3704C22.4026 15.1697 21.7491 14.7309 21.2832 14.1218C20.8172 13.5126 20.5647 12.7671 20.5647 12.0001C20.5647 11.2332 20.8172 10.4876 21.2832 9.8785C21.7491 9.26937 22.4026 8.83057 23.1428 8.62985V5.143C23.1428 4.68893 22.9627 4.25342 22.6419 3.93202C22.3212 3.61063 21.886 3.42962 21.432 3.42871H2.56797C2.11391 3.42962 1.67876 3.61063 1.35801 3.93202C1.03726 4.25342 0.857116 4.68893 0.857117 5.143V8.623C1.60321 8.81923 2.26331 9.257 2.73436 9.86797C3.20541 10.4789 3.46088 11.2287 3.46088 12.0001C3.46088 12.7716 3.20541 13.5214 2.73436 14.1323C2.26331 14.7433 1.60321 15.181 0.857117 15.3773V18.8573Z",
    stroke: "currentColor",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60568 9.42864C8.83301 9.42864 9.05102 9.33834 9.21177 9.17759C9.37251 9.01684 9.46282 8.79883 9.46282 8.5715C9.46282 8.34417 9.37251 8.12615 9.21177 7.96541C9.05102 7.80466 8.83301 7.71436 8.60568 7.71436C8.37835 7.71436 8.16033 7.80466 7.99959 7.96541C7.83884 8.12615 7.74854 8.34417 7.74854 8.5715C7.74854 8.79883 7.83884 9.01684 7.99959 9.17759C8.16033 9.33834 8.37835 9.42864 8.60568 9.42864ZM15.4628 16.2858C15.6902 16.2858 15.9082 16.1955 16.0689 16.0347C16.2297 15.874 16.32 15.656 16.32 15.4286C16.32 15.2013 16.2297 14.9833 16.0689 14.8225C15.9082 14.6618 15.6902 14.5715 15.4628 14.5715C15.2355 14.5715 15.0175 14.6618 14.8567 14.8225C14.696 14.9833 14.6057 15.2013 14.6057 15.4286C14.6057 15.656 14.696 15.874 14.8567 16.0347C15.0175 16.1955 15.2355 16.2858 15.4628 16.2858Z",
    stroke: "currentColor",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupon);
export default __webpack_public_path__ + "static/media/coupon.c43ba06da186442eaadb595d0b26abde.svg";
export { ForwardRef as ReactComponent };